import { Link } from "react-router-dom";
import confirmImg from "./confirmImg.png";
import "./styles.css";

export default function ConfirmCTA() {
    return (
        <section className="confirm-section">
            <img
                src={confirmImg}
                alt="Confirmar asistencia"
                className="confirm-icon"
            />

            <h2 className="confirm-title">CONFIRMAR ASISTENCIA</h2>

            <p className="confirm-text">
                Agradecemos que confirmes tu asistencia a más tardar el 20 de octubre.
                Luego de esa fecha cerraremos nuestro listado.
            </p>

            <Link to="/confirmacion" className="confirm-button">
                Confirmar asistencia
            </Link>

            <div className="confirm-note-block">
                <h3 className="confirm-note-title">NOTA ESPECIAL</h3>
                <p className="confirm-note-text">
                    Agradecemos mucho tu puntualidad para que no te pierdas ningún momento
                    especial. Toma en cuenta el tráfico del sector y el día.
                </p>
            </div>

            <p className="confirm-closing">
                ESPERAMOS CONTAR CON SU PRESENCIA
            </p>

            <p className="confirm-thanks">¡Muchas gracias!</p>
        </section>
    );
}
